<template>
  <div :id="selector" class="carousel slide" data-ride="carousel">
    <ol class="carousel-indicators">
      <li v-for="(item, index) in img_list" class="bg-main-color" :key="index" :data-target="'#'+selector" :data-slide-to="index"
          :class="{ active: index === 0 }"></li>
    </ol>
    <EmptyImage :size=18 v-if="img_list.length === 0"></EmptyImage>
    <div v-else class="carousel-inner">
      <div v-for="(item, index) in img_list" :key="index" :class="{ 'carousel-item': true, active: index === 0 }">
        <img class="d-block w-100 h-100 rounded-3" :class="getClassNames()" :style="getStyles()" :src="getMediaUrl(item, type)" alt="">
      </div>
    </div>

    <a v-if="showControl" class="carousel-control-prev" :href="'#'+selector" role="button" data-slide="prev">
      <span class="carousel-control-prev-icon" aria-hidden="true"></span>
      <span class="sr-only">Previous</span>
    </a>
    <a v-if="showControl" class="carousel-control-next" :href="'#'+selector" role="button" data-slide="next">
      <span class="carousel-control-next-icon" aria-hidden="true"></span>
      <span class="sr-only">Next</span>
    </a>
  </div>
</template>

<script>
import {generateUuidNo, isEmpty, getMediaUrl} from "@/util/helpers";
import EmptyImage from "@/components/EmptyImage.vue";

export default {
  name: "ImageCarousel",
  components: {EmptyImage},
  props: {
    autoPlay: {
      type: Boolean,
      default: false,
    },
    showControl: {
      type: Boolean,
      default: false,
    },
    imgFitType: {
      type: String,
      default: 'cover',
    },
    showBorder: {
      type: Boolean,
      default: false,
    },
    imgWidth: {
      type: Number,
    },
    imgHeight: {
      type: Number,
    },
    img_list: {
      type: Array,
      default: () => [],
    },
    type: {
      type: String,
      default: 'original',
    },
  },
  beforeMount() {
    const randomNum = generateUuidNo();
    this.selector = `carousel_${randomNum}`;
  },
  mounted() {
    this.applyAutoPlay();
  },
  watch: {
    autoPlay() {
      this.applyAutoPlay();
    },
    img_list() {
      this.$nextTick(() => {
        this.applyAutoPlay();
      });
    },
  },
  methods: {
    getMediaUrl: getMediaUrl,
    applyAutoPlay() {
      if (typeof window === 'undefined' || !window.$) return;
      const $carousel = window.$(`#${this.selector}`);
      if (!$carousel.length) return;
      $carousel.carousel({
        interval: this.autoPlay ? 3000 : false,
      });
      if (this.autoPlay) {
        $carousel.carousel('cycle');
      } else {
        $carousel.carousel('pause');
      }
    },
    getImgFitClass(imgFitType) {
      switch (imgFitType) {
        case "fill":
          return 'fit-fill';

        case "contain":
          return 'fit-contain';

        case "cover":
        default:
          return 'fit-cover';
      }
    },
    getClassNames() {
      const imgFitClass = this.getImgFitClass(this.imgFitType);
      const borderClass = this.showBorder ? 'border border-1' : '';
      return `${imgFitClass} ${borderClass}`.trim();
    },
    getSizeStyle() {
      let style = '';
      if (!isEmpty(this.imgWidth)) {
        style += `width: ${this.imgWidth}px; `
      }

      if (!isEmpty(this.imgHeight)) {
        style += `height: ${this.imgHeight}px;`
      }

      return style;
    },
    getStyles() {
      const size = this.getSizeStyle();
      console.log('size', size);
      return `${size}`.trim();
    }
  },
  data() {
    return {
      selector: "",
    };
  }
}
</script>

<style scoped>

.imgSize {
  width: 220px;
  height: 220px;
}

.fit-contain {
  object-fit: contain;
}

.fit-cover {
  object-fit: cover;
}

.fit-fill {
  object-fit: fill;
}

</style>
